import { Injectable } from '@angular/core';
import { IChargePoint, IConfigCode, IOrganizationPricePolicy } from '@cr-driver/models.interfaces';
import { ChargePointKind, WattsonPricePolicy } from './ai.models';

@Injectable({ providedIn: 'root' })
export class AIHelperService {
  chargePointKind(chargePoint: IChargePoint | null): ChargePointKind {
    if (!chargePoint) {
      return 'NO_CP_YET';
    }

    return chargePoint.direct_ocpp ? 'DIRECT' : 'GATEWAY';
  }

  chargePointName(configurationCode: IConfigCode | null): string {
    const manufacturer = configurationCode?.wallbox.manufacturer_name.trim() ?? '';
    const model = configurationCode?.wallbox.wallbox_name.trim() ?? '';
    const name = [manufacturer, model].filter(Boolean).join(' ');

    return name || 'NO_CP_YET';
  }

  pricePolicy(policy: IOrganizationPricePolicy | null | undefined): WattsonPricePolicy {
    return policy?.price_policy ?? 'NO_POLICY_YET';
  }
}
